





























import { Vue, Component, Prop } from 'vue-property-decorator';
import Tab from './Tab.vue';
import urlHelperService from '@/core/urlHelper.service';
import bus from '@/core/bus';
import { ProductTrackerProcessBatchKey } from '@/project/tracking/gtm/ProductListTracker.vue';

@Component
export default class TabsContainer extends Vue {
    activeTab: Tab | null = null;

    tabs: Tab[] = []

    @Prop(String) headerClass!: string
    @Prop(String) contentClass!: string

    toggle(name: string) {
        if (this.activeTab && this.activeTab.name !== name) {
            this.$emit('changed', name);
        }

        for (const tab of this.tabs) {
            if (tab.name === name) {
                this.activeTab = tab;
                tab.toggle(true);
            } else {
                tab.toggle(false);
            }
        }
        bus.emit(ProductTrackerProcessBatchKey);
    }

    setup() {
        this.tabs = this.$children.filter(x => x.$options.name === 'Tab') as Tab[];
        if (this.tabs.length === 0) {
            return;
        }

        const hash = urlHelperService.getHash();
        if (hash) {
            const activeTab = this.tabs.find(x => x.hash === hash);
            if (activeTab) {
                this.activeTab = activeTab;
                activeTab.toggle(true);
            }
        }

        if (!this.activeTab) {
            for (const tab of this.tabs) {
                if (tab.isActive) {
                    this.activeTab = tab;
                    break;
                }
            }

            // Always show atleast 1 tab
            if (!this.activeTab) {
                const activeTab = this.tabs[0];
                this.activeTab = activeTab;
                activeTab.toggle(true);
            }
        }

        this.$emit('init', this.activeTab.name);
    }

    mounted() {
        this.setup();
    }
}
